import http from "@/request/axios";
import qs from "qs";
const contenTypes = {
    json: "application/json;charset=UTF-8",
    form: "application/x-www-form-urlencoded;charset=UTF-8",
    formd: "application/x-www-form-urlencoded;charset=UTF-8",
};
const post = (url, params = {}, options) => {
    options = Object.assign({}, {
            ctype: "form",
            recordLogs: true,
        },
        options
    );
    const param = options.ctype !== "json" ? qs.stringify(params) : params;
    const httpUrl = /^http(s){0,1}:/gi.test(url) ?
        url :
        `${CONFIG.CORE_CONFIG.URL}/${url}`;
    http.defaults.headers.post["Content-Type"] = contenTypes[options.ctype];
    if (options.ctype === "formd") {
        http.defaults.transformRequest = [
            function(data) {
                let ret = "";
                for (let it in data) {
                    ret +=
                        it + "=" + data[it] + "&";
                }
                return ret;
            },
        ];
    }
    const handle = http.post(httpUrl, param);
    return handle;
};
const get = (url, params = {}) => {
    const httpUrl = /^http(s){0,1}:/gi.test(url) ? url : `${CONFIG.CORE_CONFIG.URL}/${url}`;
    const handle = http.get(httpUrl, {
        params: Object.assign({ t: +new Date() }, params),
    });
    return handle;
};

export { post, get };